import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LearningPlanGoalServiceInterface } from '.';
import { LearningPlanGoalApi, LearningPlanGoalInkApi } from '../+api';
import { LearningPlanGoalInterface } from '../+models';

@Injectable({
  providedIn: 'root',
})
export class LearningPlanGoalService implements LearningPlanGoalServiceInterface {
  private learningPlanGoalPolpoApi = inject(LearningPlanGoalApi);
  private learningPlanGoalInkApi = inject(LearningPlanGoalInkApi);

  getLearningPlanGoals(
    searchTerm?: string,
    filters?: { [key: string]: string | number | number[] },
    pagination?: { from?; amount? },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: LearningPlanGoalInterface[]; count: number }> {
    return this.learningPlanGoalPolpoApi.filtered(searchTerm, filters, pagination, columns, sorting);
  }

  search(
    searchTerm?: string,
    filters?: { [key: string]: string | number | number[] },
    pagination?: { from?; amount? },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: LearningPlanGoalInterface[]; count: number }> {
    return this.learningPlanGoalInkApi.search(searchTerm, filters, pagination, columns, sorting);
  }
}
